import React, { useCallback, useMemo } from 'react';

import QuickFilters, { SPECIAL_OPTION_IDS } from 'components/Filters/Common/QuickFilters';
import { COMPONENTS, SECTIONS } from 'components/Globals/Analytics/constants';
import IndexPageFilters from 'components/Manager/Display/IndexPageFilters';

import { AGGREGATION_ON, TP, SORT_OPTION_VALUES } from 'constants/index';
import useNavigate from 'utils/hooks/useNavigate';
import { useQuery } from 'utils/react-query';

import queries from 'containers/Managers/queries';

import { useTranslation } from 'src/i18n';

import { ENTITY_TYPES, FILTER_TYPES } from 'operabase-router/constants';

import EntitySectionFilters from '../Common/EntitySectionFilters';
import EntitySwimLane from '../Common/EntitySwimLane';
import FeaturedEntitySection from '../Common/FeaturedEntitySection';

import classes from './FeaturedAgencies.module.scss';

const trackingData = {
  section: SECTIONS.FEATURED_AGENCIES,
};

const FeaturedAgencies = ({ limit = 5 }) => {
  const { t } = useTranslation('NS_APP_GLOBALS');
  const navigate = useNavigate();
  const linkProps = useMemo(
    () =>
      navigate.getLinkProps({
        entityType: ENTITY_TYPES.AGENCY,
        filters: {
          [FILTER_TYPES.ORGANIZATION_TYPE]: [
            {
              entityType: ENTITY_TYPES.ORGANIZATION_TYPE,
              entity: { id: 70 },
            },
          ],
        },
      }),
    [navigate],
  );

  const { data } = useQuery(
    queries.getHomepageFeaturedAgencies({
      filters: {
        sort: `${SORT_OPTION_VALUES.PRO_STATUS_DESC},${SORT_OPTION_VALUES.FEATURED_DESC}`,
        car: true,
      },
      limit,
      queryConfig: {
        select: response => response?.slice(0, limit),
      },
    }),
  );

  const baseFilterLinkProps = useMemo(
    () => ({
      entityType: ENTITY_TYPES.ORGANIZATION,
      filters: {
        [FILTER_TYPES.ORGANIZATION_TYPE]: [
          {
            entityType: ENTITY_TYPES.ORGANIZATION_TYPE,
            entity: { id: 70 },
          },
        ],
      },
    }),
    [],
  );

  const onViewAllHandler = useCallback(
    (e, option) => {
      if (option?.id === SPECIAL_OPTION_IDS.ALL) {
        navigate.to(navigate.getLinkProps(baseFilterLinkProps));
      }
    },
    [navigate, baseFilterLinkProps],
  );

  return (
    <FeaturedEntitySection title={t(`${TP}.m_AGENCIES_AND_MANAGERS`)} linkProps={linkProps} trackingData={trackingData}>
      <EntitySectionFilters allowedEntityTypes={[ENTITY_TYPES.AGENCY]} trackingData={trackingData}>
        <IndexPageFilters className={classes.filters} hideSearch />
      </EntitySectionFilters>
      <QuickFilters
        aggregationOn={AGGREGATION_ON.MANAGERS}
        filterType={FILTER_TYPES.PROFESSION}
        limit={10}
        baseLinkProps={baseFilterLinkProps}
        titleKey={`${TP}.FN_FILTER_AGENCY_BY_SEO_LABEL`}
        onOptionClick={onViewAllHandler}
        variant="h3"
        hasCustomViewAllHandler
        collapsable
        enableCache
        trackingData={{
          ...trackingData,
          component: COMPONENTS.QUICK_FILTERS,
        }}
      />
      <EntitySwimLane data={data} trackingData={trackingData} />
    </FeaturedEntitySection>
  );
};

export default FeaturedAgencies;
